// A declined quotation can be charged again once the customer replaces the card, and a card
// only counts as replaced if it changed after the last attempt: paymentMethodStatus stays
// "CHANGED" after a later decline. Keep in sync with isChargeableAfterCardChange in
// routes/api/flywire.js, or the page offers a charge the API rejects.
export const isQuotationRetryableAfterCardChange = (quotation) => {
  if (quotation?.paymentStatus !== "CHARGE_FAILED") return false;
  if (quotation?.paymentMethodStatus !== "CHANGED") return false;

  const cardUpdatedAt = new Date(quotation?.paymentMethodUpdatedAt).getTime();
  const lastChargeAt = new Date(quotation?.flywireChargedAt).getTime();

  if (!Number.isFinite(cardUpdatedAt) || !Number.isFinite(lastChargeAt)) return true;

  return cardUpdatedAt > lastChargeAt;
};
